<template>
  <vx-card class="vx-card_full-height" title="Архив тарифов">
    <TabsHeader :tabs="apartmentTypes" :on-change="onSelectApartmentType" :active="selectedApartmentType" />
    <div :class="$style.wrapper">
      <div :class="$style.container">
        <div :class="$style.sidebar">
          <div :key="group.id" v-for="group in tariffGroups">
            <div :class="$style.groupTitle">{{ group.name }}</div>
            <div
              :key="tariff.id"
              v-for="tariff in groupedTariffs[group.id]"
              :class="[$style.tariffItem, selectedTariff && selectedTariff.id === tariff.id && $style.tariffItemActive]"
              @click="onSelectTariff(tariff)"
            >
              {{ tariff.name }}
            </div>
          </div>
        </div>

        <div :class="$style.content" v-if="selectedTariff">
          <div :class="$style.tariffTitle">{{ selectedTariff.name }}</div>
          <div :class="$style.tariffInfo">
            <table :class="$style.info">
              <tr>
                <td>Не выводить квитанцию на пустое значение:</td>
                <td>{{ selectedTariff.show_empty ? 'Да' : 'Нет' }}</td>
              </tr>
              <tr>
                <td>Участвует в расчете пени:</td>
                <td>{{ selectedTariff.count_fine ? 'Да' : 'Нет' }}</td>
              </tr>
              <tr>
                <td>Тип помещения:</td>
                <td>{{ selectedTariffApartmentType }}</td>
              </tr>
              <tr>
                <td>Единица измерения:</td>
                <td>{{ selectedTariffUnit }}</td>
              </tr>
              <tr>
                <td>Расчет за:</td>
                <td>{{ selectedTariffType }}</td>
              </tr>
            </table>

            <div class="px-4 tariffs-section-no-icon">
              <div
                class="flex flex-wrap"
                v-for="(tariffValue, index) in selectedTariff.tarifs_value"
                :key="`tariffValue-${index}`"
              >
                <template v-if="tariffValue.type_value === 0">
                  <vs-input
                    label="Основной тариф"
                    class="mb-base mr-base"
                    v-model="tariffValue.value"
                    disabled
                  ></vs-input>
                  <div>
                    <label :for="`tariffValue-startDate${index}`" class="vs-input--label">Действует c</label>
                    <datepicker
                      class="mb-base mr-base"
                      format="dd.MM.yyyy"
                      :ref="`tariffValue-startDate${index}`"
                      v-model="tariffValue.start_date"
                      disabled
                      :id="`tariffValue-startDate${index}`"
                    />
                  </div>
                  <div>
                    <label :for="`tariffValue-endDate${index}`" class="vs-input--label">Действует по</label>
                    <datepicker
                      class="mb-base mr-base"
                      format="dd.MM.yyyy"
                      :ref="`tariffValue-endDate${index}`"
                      v-model="tariffValue.end_date"
                      disabled
                      :id="`tariffValue-endDate${index}`"
                    />
                  </div>
                </template>
              </div>
            </div>

            <vs-collapse>
              <vs-collapse-item ref="extraConditionCollapseItem">
                <div slot="header">
                  Дополнительные условия
                </div>

                <div class="vx-row">
                  <div class="vx-col w-full">
                    <div class="border border-solid border-grey p-4">
                      <div class="vx-row flex justify-between items-center mb-base ">
                        <div class="px-4 flex-1 items-center flex">
                          <span class="italic text-lg">между условиями логическое ИЛИ</span>
                        </div>

                      </div>
                      <template v-for="(tariffValue, index) in selectedTariff.tarifs_value">
                        <div
                          class="vx-row flex-wrap mb-4 items-center"
                          v-if="tariffValue.type_value !== 0"
                          :key="`extraCondition${index}`"
                        >
                          <div class="vx-col w-full md:w-auto flex-initial mt-1">если</div>
                          <div class="vx-col w-full md:w-auto flex-1">
                            <div class="vx-row">
                              <div class="vx-col md:w-1/2 w-full tariff-extra-condition__col tariff-extra-condition__flat mb-4">
                                <vs-select class="w-full" label=" " v-model="tariffValue.type_value" disabled>
                                  <vs-select-item
                                    :key="extraTariffsType.value"
                                    :value="extraTariffsType.value"
                                    :text="extraTariffsType.label"
                                    v-for="extraTariffsType in extraTariffsTypes"
                                  />
                                </vs-select>
                              </div>
                              <template v-if="tariffValue.type_value === 2">
                                <div class="vx-col mb-4 w-full md:w-1/2 tariff-extra-condition__col tariff-extra-condition__info">
                                  <listInput :list="tariffValue.list" @change="tariffValue.list = $event" disabled />
                                </div>
                              </template>
                              <template v-if="tariffValue.type_value === 1">
                                <div class="flex mb-4 w-full md:w-1/2 tariff-extra-condition__info">
                                  <div class="vx-col tariff-extra-condition__col w-1/2 px-4">
                                    <vs-input
                                      class="w-full"
                                      label="От"
                                      v-model="tariffValue.from"
                                      :disabled="!(tariffValue.isNew === true)"
                                    />
                                  </div>
                                  <div class="vx-col tariff-extra-condition__col w-1/2 px-4">
                                    <vs-input
                                      class="w-full"
                                      label="До"
                                      v-model="tariffValue.to"
                                      :disabled="!(tariffValue.isNew === true)"
                                    />
                                  </div>
                                </div>
                              </template>
                              <div class="vx-col w-full mb-4 tariff-extra-condition__col tariff-extra-condition__tariff">
                                <vs-input
                                  class="w-full"
                                  label="Тариф"
                                  v-model="tariffValue.value"
                                  :disabled="!(tariffValue.isNew === true)"
                                ></vs-input>
                              </div>
                              <div class="vx-col w-full mb-4 tariff-extra-condition__col tariff-extra-condition__startDate">
                                <div>
                                  <label for="extra-tarifValue-startDate" class="vs-input--label">Действует c</label>
                                  <datepicker
                                    class="w-full"
                                    v-model="tariffValue.start_date"
                                    format="MMMM yyyy"
                                    :minimumView="'month'"
                                    :maximumView="'year'"
                                    id="extra-tarifValue-startDate"
                                    :disabled="!(tariffValue.isNew === true)"
                                  ></datepicker>
                                </div>
                              </div>
                              <div class="vx-col w-full mb-4 tariff-extra-condition__col tariff-extra-condition__endDate">
                                <div>
                                  <label for="extra-tarifValue-endDate" class="vs-input--label">Действует по</label>
                                  <datepicker
                                    class="w-full"
                                    v-model="tariffValue.end_date"
                                    format="MMMM yyyy"
                                    :minimumView="'month'"
                                    :maximumView="'year'"
                                    id="extra-tarifValue-endDate"
                                    :disabled="!(tariffValue.isNew === true)"
                                  ></datepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>

              </vs-collapse-item>
            </vs-collapse>

            <div class="px-4 mb-base">
              <div class="vx-row">
                <div class="vx-col w-full flex justify-end">
                  <vs-button
                    type="filled"
                    color="danger"
                    class="mr-4"
                    @click="deleteTarif"
                    v-if="$can('rp.tariffs', 'write')"
                  >
                    В действующие
                  </vs-button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import listInput      from "@/components/calculated-program/tariffs/TariffExtraConditionsListInput";
import TabsHeader     from "@/components/TabsHeader";
import arrayToIdIndex from "@/client/helpers/arrayToIdIndex";

export default {
  name:       "TariffsArchive",
  components: {
    TabsHeader,
    listInput,
  },
  data() {
    return {
      groupedTariffs: {},
      tariffGroups:   [],
      units:          [],
      tariffTypes:    [],
      selectedTariff: null,
    };
  },
  computed: {
    selectedApartmentType() {
      return +this.$route.params.apartmentsType;
    },

    apartmentTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },

    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },

    apartmentTypeDict() {
      return arrayToIdIndex(this.apartmentTypes);
    },

    unitsDict() {
      return arrayToIdIndex(this.units);
    },

    tariffTypesDict() {
      return arrayToIdIndex(this.tariffTypes, 'tariffs_type');
    },

    selectedTariffApartmentType() {
      const type = this.apartmentTypeDict[this.selectedTariff.apartments_type];
      return type ? type.name : '-';
    },
    selectedTariffUnit() {
      const unit = this.unitsDict[this.selectedTariff.unit_id];
      return unit ? unit.name : '-';
    },
    selectedTariffType() {
      const type = this.tariffTypesDict[this.selectedTariff.type_tarif];
      return type ? type.name : '-';
    },
  },
  methods:  {
    loadUnits() {
      this.$http.get('units').then(( { data } ) => this.units = data);
    },

    loadTariffTypes() {
      return this.$http.get('tarif_types', { params: { buildings_id: this.selectedHouseId } }).then(( { data } ) => this.tariffTypes = data);
    },

    loadTariffs() {
      return Promise.all([
        this.$http.get('tarif_group', { params: { buildings_id: this.selectedHouseId } }),
        this.$http.get('tarifs', {
          params: {
            buildings_id:    this.selectedHouseId,
            apartments_type: this.selectedApartmentType,
            archive:         true,
          },
        }),
      ]).then(( [{ data: tariffGroups }, { data: tariffs }] ) => {
        const groupedTariffs = {};
        let firstTariff = null;

        tariffs.sort(( a, b ) => a.position - b.position);
        tariffs.forEach(tariff => {
          if (!tariff.tarifs_group) return;
          const groupId = tariff.tarifs_group.id;
          if (!groupedTariffs[groupId]) groupedTariffs[groupId] = [];
          groupedTariffs[groupId].push(tariff);
          if (!firstTariff) firstTariff = tariff;
        });

        this.tariffGroups = tariffGroups.filter(group => !!groupedTariffs[group.id]);
        this.groupedTariffs = groupedTariffs;
        if (firstTariff) this.onSelectTariff(firstTariff);
      });
    },

    async acceptDeleteTarif() {
      try {
        if (this.selectedTariff.id) {
          let body = Object.assign(this.selectedTariff, { buildings_id: this.selectedHouseId, is_archive: false });
          delete body.tarifs_value;
          delete body.formula;
          let group = this.tariffGroups.find(group => group.id === this.selectedTariff.tarifs_group.id);
          this.selectedTariff.tarifs_group = group.id;
          let { data } = await this.$http.put('tarifs/' + this.selectedTariff.id, body);
          this.loadTariffs();
        }
      } catch (e) {
        console.log(e);
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
      }
    },

    deleteTarif() {
      this.$vs.dialog({
        type:       'confirm',
        color:      'danger',
        title:      'Подтверждение',
        text:       'Вы уверены что хотите восстановить тариф?',
        acceptText: 'Восстановить',
        cancelText: 'Отменить',
        accept:     this.acceptDeleteTarif,
      });
    },

    checkApartmentType( cb ) {
      const selectedApartmentType = this.selectedApartmentType;
      let newApartmentType = null;
      if (Number.isNaN(selectedApartmentType)) {
        newApartmentType = this.apartmentTypes[0].id;
      } else {
        const selectedType = this.apartmentTypes.find(type => type.id === selectedApartmentType);
        if (!selectedType) newApartmentType = this.apartmentTypes[0].id;
      }

      if (newApartmentType === null) {
        cb();
      } else {
        this.$router.replace({ params: { apartmentsType: newApartmentType } });
      }
    },

    onSelectApartmentType( apartmentsType ) {
      this.$router.replace({ params: { apartmentsType } });
    },

    onSelectTariff( tariff ) {
      this.selectedTariff = tariff;
    },
  },
  mounted() {
    this.loadUnits();
    this.loadTariffTypes();
    this.checkApartmentType(() => {
      this.loadTariffs();
    });
  },
  watch: {
    selectedApartmentType() {
      this.loadTariffs();
      this.onSelectTariff(null);
    },
    selectedHouseId() {
      this.checkApartmentType(() => {
        this.loadTariffs();
        this.onSelectTariff(null);
      });
    },
  },
};
</script>

<style lang="scss" module>
$borderColor: #dae1e7;

.wrapper {
  position: relative;
  flex: 1;
  margin: 0 -1.5rem -1.5rem;
}

.container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  border-top: 1px solid $borderColor;
}

.sidebar {
  width: 260px;
  border-right: 1px solid $borderColor;
  overflow: auto;
}

.groupTitle {
  font-size: 16px;
  font-weight: 500;
  padding: 10px;
}

.tariffItem {
  padding: 0 10px 10px 15px;
  @include anim();
  cursor: pointer;

  &:hover {
    color: color(primary);
  }
}

.content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.tariffItemActive {
  color: color(primary);
}

.tariffTitle {
  border-bottom: 1px solid $borderColor;
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  font-size: 1.2rem;
  font-weight: 500;
}

.tariffInfo {
  overflow: auto;
  padding: 1em;
  flex: 1;
  min-height: 0;
}

.info {
  margin-bottom: 1em;

  td {
    padding-bottom: .5em;

    &:first-child {
      padding-right: 10px;
    }

    &:last-child {
      font-weight: 500;
    }
  }
}
</style>
